/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateCampaignsMetadata} from '../api'

export const useMutationUpdateCampaignsMetadata = createReactQueryMutationHook('updateCampaignsMetadata', updateCampaignsMetadata)
